import React from 'react'

const Title = ({ title, punctuation, color, spacing }) => {
    return (
        <div className={`font-size-64 font-pnb color-main-black line-height-1 ${spacing === "big" ? "mb-3 mb-lg-5" : "mb-3"}`} style={{ color: `${color || "#323232"}` }}>{title}{punctuation}</div>
    )
}

export default Title